import PageBackTitle from "../../../Component/PageBackTitle";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../../../src/Config";
import Select from "react-select";

function EditGasCalibration({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [departmentData, setDepartmentData] = useState({
    GasName: "",
    GasConcentration: "",
    EngineeringUnit: "",
    formula: "",
  });
  const { id } = useParams();
  const unitOptions = [
    { value: "ppm", label: "ppm" },
    { value: "%", label: "%" },
    { value: "mg/m³", label: "mg/m³" },
  ];

  useEffect(() => {
    if (id) {
      fetchCalibrationGasType(id);
    }
  }, [id]);

  const fetchCalibrationGasType = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await fetch(
        `${API_URL}/api/get_calibration_gas_type/${id}`,
        {
          method: "GET",
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch gas type");

      const data = await response.json();
      console.log("Fetched Gas Type:", data);

      setDepartmentData({
        GasName: data.gas_name,
        GasConcentration: data.concentration,
        formula: data.formula,
        EngineeringUnit: data.standard_unit,
      });
    } catch (error) {
      console.error("Error fetching calibration gas type:", error);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDepartmentData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleCancelClick = () => {
    window.history.back();
  };

  const validateForm = () => {
    const validationErrors = {};
    if (!departmentData.GasName) {
      validationErrors.GasName = "Gas name is required.";
    }
    if (!departmentData.GasConcentration) {
      validationErrors.GasConcentration = "Gas Concentration is required.";
    }
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleSaveClick = async () => {
    if (!validateForm()) return;

    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const payload = {
        gas_name: departmentData.GasName,
        concentration: departmentData.GasConcentration,
        formula: departmentData.formula,
        standard_unit: departmentData.EngineeringUnit,
      };

      const response = await axios.put(
        `${API_URL}/api/update_calibration_gas_type/${id}`,
        payload,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );

      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Gas Calibration Updated SucessFully");
        setTimeout(() => {
          navigate("/calibration-gas-types");
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving department:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveClick();
    }
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content">
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">Edit Calibration Gas</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail" onKeyDown={handleKeyDown}>
              <div className="new-data-form">
                <div className="form-group">
                  <label htmlFor="DepartmentName">
                    Gas Name<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="GasName"
                      value={departmentData.GasName}
                      onChange={handleInputChange}
                      placeholder="Enter Gas Name"
                    />
                  </div>
                  {errors.GasName && (
                    <div className="error-message">{errors.GasName}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="DepartmentName">
                    Gas Concentration<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="number"
                      name="GasConcentration"
                      value={departmentData.GasConcentration}
                      onChange={handleInputChange}
                      placeholder="Enter Gas Concentration"
                    />
                  </div>
                  {errors.GasConcentration && (
                    <div className="error-message">
                      {errors.GasConcentration}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="DepartmentName">Formula</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="formula"
                      value={departmentData.formula}
                      onChange={handleInputChange}
                      placeholder="Enter Gas Formula"
                    />
                  </div>
                </div>
                <div className="form-group-select">
                  <label htmlFor="DepartmentName">
                    Engineeing Unit<span className="text-danger">*</span>
                  </label>
                  <Select
                    name="EngineeringUnit"
                    isClearable
                    options={unitOptions}
                    value={unitOptions.find(
                      (opt) => opt.value === departmentData.EngineeringUnit
                    )}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "EngineeringUnit",
                          value: selectedOption ? selectedOption.value : "", // or null
                        },
                      })
                    }
                    placeholder="Select unit"
                  />
                </div>
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="save"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default EditGasCalibration;
